import { render, staticRenderFns } from "./detailDiscount.vue?vue&type=template&id=ff55e1d0"
import script from "./detailDiscount.vue?vue&type=script&lang=js"
export * from "./detailDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports